module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<a on-click=\"onBredcrumbItemClick\" class=\"breadcrumb-item\" data-deep=\"")
    ; __append(escapeFn(deep))
    ; __append("\">")
    ; __append(escapeFn( item[widget.titleKey] ))
    ; __append("</a>\n")
    ; __append(escapeFn( (item.options && item.options.dictid?' >':'.')))
    ; __append("\n")
  }
  return __output.join("");

}